export function formFileUpload() {
    // Replace default Form Upload
    const fileUploads = document.querySelectorAll(".ginput_container_fileupload");

    fileUploads.forEach((fileUpload) => {
        var para = document.createElement("span");
        var node = document.createTextNode("Upload a document (Max. size: 3 MB)");
        para.classList.add("inputFileSelector", "fs-20");
        para.appendChild(node);
        fileUpload.appendChild(para);
    });

    // Add the file name in the new style
    const fileNames = document.querySelectorAll("input[type=file]");
    if (document.querySelector('.ginput_container_fileupload')) {
        document.querySelector('.ginput_container_fileupload > input[type=file]').style.width = '100%';
    }
   

    fileNames.forEach((fileName) => {
        fileName.addEventListener("change", function () {
            if (this.files.length > 0) {
                if (this.files[0]) {
                    if (this.files[0].name.length > 30) {
                        fileName.parentNode.querySelector(".inputFileSelector").innerHTML = this.files[0].name.substring(0, 30) + '...';
                    } else {
                        fileName.parentNode.querySelector(".inputFileSelector").innerHTML = this.files[0].name;
                    }
                } else {
                    fileName.parentNode.querySelector(".inputFileSelector").innerHTML = "Upload a document (Max. size: 3 MB)";
                }
                fileName.parentNode.classList.add("active");
            } else {
                fileName.parentNode.querySelector(".inputFileSelector").innerHTML = "Upload a document (Max. size: 3 MB)";
            }
        });
    }); 
}